// extracted by mini-css-extract-plugin
module.exports = {"label":"formInput_label__2201p"};